import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_CLEAR_DOMAINS,
  ALL_INCIDENTS_FILTERS_FETCH_DOMAINS,
} from '../../../../actions/actionTypes';

export default fetchReducerGenerator(
  [ALL_INCIDENTS_CLEAR, ALL_INCIDENTS_FILTERS_CLEAR_DOMAINS],
  ALL_INCIDENTS_FILTERS_FETCH_DOMAINS
);

export const getAllIncidentsDomainsResponseForProjection = responseData => {
  return responseData.map(({ domainId, url }) => ({
    title: url,
    value: domainId,
    key: domainId,
  }));
};

export const getAllIncidentsDomainsResponse = state => {
  if (state.response && state.response.data) {
    return getAllIncidentsDomainsResponseForProjection(state.response.data);
  } else {
    return [];
  }
};
